import React, { useState, useEffect } from "react";
import ScheduleTable from './ScheduleTable';
import EditLessonModal from './EditLessonModal';
import EditEventModal from './EditEventModal';
import { Link } from "react-router";
import { getCurrentUser } from 'aws-amplify/auth';

function OneArticlePage({ item, type }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        getCurrentUser()
            .then(user => setUser(user))
            .catch(() => setUser(null)); // not signed in
    }, []);

    if (!(item)) {
        return <>Niet gevonden</>
    }

    const handleEditClick = () => {
        setIsModalOpen(true);
    };

    const handleModalClose = (wasSuccessful) => {
        setIsModalOpen(false);
    };

    return (
        <>
            <section className="about_section" key="lesson-body">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2>
                            {item.name}
                        </h2>
                        {user && (
                            <button 
                                className="btn btn-primary"
                                onClick={handleEditClick}
                            >
                                {type === "event" ? "Edit Event" : type === "lesson" ? "Edit Lesson" : "Edit"}
                            </button>
                        )}
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="about-detail">
                                {item.body.split('\n').map((str, i) => <p key={item.name + "-" + i}>{str}</p>)}
                                {!('schedules' in item) && <><br/><Link to="https://www.ledenbeheer.be/public/tmdancecompany">
                                    Inschrijven
                                </Link></>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="about-imge-box">
                                <img src={item.img} alt={`${item.name}`} className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {('schedules' in item) &&
                <section className="about_section" key="lesson-table">
                    <div className='container'>
                        <h2>
                            Lessenrooster voor {item.name}
                        </h2>
                        <ScheduleTable lessons={[item]} />
                    </div>
                </section>
            }
            {!(type==="event") && isModalOpen && (
                <EditLessonModal
                    isOpen={isModalOpen}
                    onClose={handleModalClose}
                    link={item.link}
                    name={item.name}
                    isNew={false}
                />
            )}
            {type==="event" && isModalOpen && (
                <EditEventModal
                    isOpen={isModalOpen}
                    onClose={handleModalClose}
                    link={item.link}
                    name={item.name}
                    isNew={false}
                />
            )}
        </>
    )
}

export default OneArticlePage;
